import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { QrObraAdminStatus } from '../../models/qr-obra-admin-status.model';
import { QrObraAdminStatusService } from '../../services/qr-obra-admin-status-service';

@Component({
  selector: 'app-obras-admin-status-list',
  templateUrl: './obras-admin-status-list.component.html',
  styleUrls: ['./obras-admin-status-list.component.scss']
})
export class ObrasAdminStatusListComponent extends BaseListComponent<any> implements OnInit {

  statusList: QrObraAdminStatus[];

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: QrObraAdminStatusService,
  ) {
    super();
  }

  ngOnInit() {
    this.loading();
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.statusList = res;
        this.loaded();
      })
    );
  }

}
